import { React, useState, useEffect } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { apiCall, apiCallAsync } from '../apiclient';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Nav from 'react-bootstrap/Nav';
import Tab from 'react-bootstrap/Tab';
import SongListCatalogCriteria from './SongListCatalogCriteria';
import SongListTagCriteria from './SongListTagCriteria';
import SongListListCriteria from './SongListListCriteria';
import SongListSongCriteria from './SongListSongCriteria';
import SongListTable from './SongListTable';


export default function SongLists(props) {
    /* props.user is the current user */

    const [currentListName, setCurrentListName] = 
        useState('');
    const [currentListProps, setCurrentListProps] =
        useState(null);
    const [currentCriteria, setCurrentCriteria] = 
        useState(JSON.stringify({'criteria': []}));
    const [userLists, setUserLists] =
        useState([]);
    const [currentSongList, setCurrentSongList] =
        useState([]);

    useEffect(() => {
        if (JSON.parse(currentCriteria).criteria.length > 0) {
            /* let curCriteria = {"criteria": [{"include_tags":["CC",]},
                                            {"exclude_tags":["Country","CW"]}]};
            setCurrentCriteria(curCriteria); */
            console.log(`SongLists.useEffect() currentCriteria: ${currentCriteria}`);
            apiCall('post', 'songlist', JSON.parse(currentCriteria)).then((rtnObj) => {
                // console.log(JSON.stringify(rtnObj));
                setCurrentSongList(rtnObj);
            }).catch((err) => {
                console.log("SongLists songlist api error " + err);
            })
        }
    }, [currentCriteria]);

    function currentCriteriaSetter(criteria) {
        console.log(`SongLists.currentCriteriaSetter(${criteria})`);
        if (criteria !== null) {
            setCurrentCriteria(criteria);
        }
        console.log(`SongLists.currentCriteriaSetter criteria: ${currentCriteria}`)
    }

    return(
      <DndProvider backend={HTML5Backend}>
        <Container style={{ 'height': '90vh', 'max-height': '90vh'}}>
            <p></p>
            <Row style={{ 'height': '5%', 'max-height': '5%' }}>
               <Col className='border'>List Selection</Col> 
            </Row><div style={{ 'height': '2%', 'max-height': '2%' }}></div>
            <Row style={{ 'height': '49%', 'max-height': '49%' }}>
            <Tab.Container id='selection-criteria' defaultActiveKey='tags'>
                <Col className='border' style={{ 'height':'100%', 'max-height': '100%'}}
                         sm={2}>
                    <Nav variant='pills' className='flex-column'>
                        <Nav.Item>
                            <Nav.Link eventKey='catalogs'>Catalogs</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey='tags'>Tags</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey='lists'>Lists</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey='songs'>Songs</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col className='border' style={{ 'height':'100%', 'max-height': '100%'}}
                        sm={10}>
                    <Tab.Content>
                        <Tab.Pane eventKey='catalogs'>
                        <SongListCatalogCriteria user={props.user} />
                        </Tab.Pane>
                    </Tab.Content>
                    <Tab.Content>
                        <Tab.Pane eventKey='tags'>
                        <SongListTagCriteria user={props.user} 
                                    currentCriteria={currentCriteria} 
                                    currentCriteriaUpdate={currentCriteriaSetter} />
                        </Tab.Pane>
                    </Tab.Content>
                    <Tab.Content>
                        <Tab.Pane eventKey='lists'>
                        <SongListListCriteria user={props.user} />
                        </Tab.Pane>
                    </Tab.Content>
                    <Tab.Content>
                        <Tab.Pane eventKey='songs'>
                        <SongListSongCriteria user={props.user} />
                        </Tab.Pane>
                    </Tab.Content>
                </Col>
            </Tab.Container>
            </Row>
            <div style={{ 'height': '2%', 'max-height': '2%'}}></div>
            <Row style={{ 'height': '42%', 'max-height': '42%'}}>
                <Col className='border' sm={10} style={{ 'height': '100%', 'max-height': '100%'}}>
                    <SongListTable songs={currentSongList} />
                </Col>
                <Col className='border' sm={2}>
                    Save, Preview, Export Here
                </Col>
            </Row>
        </Container>
      </DndProvider>
    )
}